module.exports = __webpack_public_path__ + "static/media/server-error.78a5588b.svg";